module.exports = __webpack_public_path__ + "img/19.519abd22.png";